import React from 'react';
import { Grape, Apple, Home, Waves, DoorOpen } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const iconMap = {
  Grape,
  Apple,
  Home,
  Waves,
  DoorOpen,
  Fence: Home
};

const Applications = () => {
  const { t } = useTranslation();
  
  // Applications data with translation keys
  const applications = [
    {
      id: 1,
      titleKey: 'applications.items.vineyards.title',
      descriptionKey: 'applications.items.vineyards.description',
      icon: 'Grape',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/66ifdme8_DSC00100.JPG"
    },
    {
      id: 2,
      titleKey: 'applications.items.orchards.title',
      descriptionKey: 'applications.items.orchards.description',
      icon: 'Apple',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/w9k5r3oz_IMG_9846.jpeg"
    },
    {
      id: 3,
      titleKey: 'applications.items.fencing.title',
      descriptionKey: 'applications.items.fencing.description',
      icon: 'Fence',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/50fu00ts_simple%20torsion.jpg"
    },
    {
      id: 4,
      titleKey: 'applications.items.construction.title',
      descriptionKey: 'applications.items.construction.description',
      icon: 'Home',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/df38s8ah_WhatsApp%20Image%202026-03-27%20at%2019.23.52.jpeg"
    },
    {
      id: 5,
      titleKey: 'applications.items.decks.title',
      descriptionKey: 'applications.items.decks.description',
      icon: 'Waves',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/hjfqtb9p_WhatsApp%20Image%202026-03-27%20at%2019.11.16.jpeg"
    },
    {
      id: 6,
      titleKey: 'applications.items.gates.title',
      descriptionKey: 'applications.items.gates.description',
      icon: 'DoorOpen',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/3ln3xuab_WhatsApp%20Image%202026-03-27%20at%2019.33.23.jpeg"
    }
  ];
  
  return (
    <section id="applications" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-cmv-green font-semibold text-sm uppercase tracking-wider">
            {t('applications.label')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            {t('applications.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('applications.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {applications.map((app) => {
            const Icon = iconMap[app.icon] || Home;
            return (
              <div
                key={app.id}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500"
              >
                {/* Background Image */}
                <div className="relative h-64 md:h-80 overflow-hidden">
                  <img
                    src={app.image}
                    alt={t(app.titleKey)}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                </div>

                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-cmv-green rounded-lg flex items-center justify-center mb-3 md:mb-4 transform transition-transform group-hover:scale-110">
                    <Icon className="text-white" size={24} />
                  </div>
                  
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3">
                    {t(app.titleKey)}
                  </h3>
                  
                  <p className="text-sm md:text-base text-gray-200 leading-relaxed">
                    {t(app.descriptionKey)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Applications;
